import { api } from './api';

export type SessionType = 'ONE_ON_ONE' | 'GROUP';
export type SessionStatus = 'SCHEDULED' | 'COMPLETED' | 'CANCELLED';

export interface TutorInfo {
  id: string;
  name: string | null;
  tutorProfile: { displayName: string; avatarUrl: string | null } | null;
}

export interface Session {
  id: string;
  title: string;
  type: SessionType;
  status: SessionStatus;
  scheduledStart: string;
  scheduledEnd: string;
  meetingUrl?: string;
  notes?: string;
  tutor?: TutorInfo | null;
  createdAt: string;
}

export const sessionsService = {
  findAll: () => api.get<Session[]>('/sessions'),
  update: (id: string, dto: Partial<{ status: SessionStatus; notes: string; title: string }>) =>
    api.patch<Session>(`/sessions/${id}`, dto),
  remove: (id: string) => api.delete<void>(`/sessions/${id}`),
};
